import axios from 'axios';

import settings from '../libs/config';
import Logger from '../functions/logging';
import ApiError from './apiError.js';

const getAssetCommentsEndpoint = settings.api_host + "/users/viewer_comments";
const postAssetCommentEndpoint = settings.api_host + "/event/viewer_comment";

export const getAssetComments = async (asset_id, user_token) => {
	if (!asset_id) {
		throw new Error("Missing Asset ID");
	}

	Logger.log(this.constructor.name, "getAssetComments()", getAssetCommentsEndpoint);

	try {
		const response = await axios.get(getAssetCommentsEndpoint, {
			params: {
				asset_id,
				user_token
			}
		});

		// Logger.log(this.constructor.name, "getAssetComments() response", response);

		const data = response.data;
		return data.result;
	} 
	catch (error) {
		throw new ApiError(error);
	}
};

export const postAssetComment = async (commentData, user_token) => {
	const { group_id, research_env, panel_segment, asset_id, user_id, text, timecode, username, profilePictureNumber } = commentData;

	if (!user_token) throw new Error("Missing User Token");
	if (!group_id) throw new Error("Missing Group ID");
	if (!panel_segment && panel_segment !== 0) throw new Error("Missing Panel Segment");
	if (!research_env) throw new Error("Missing Research Environment");
	if (!asset_id) throw new Error("Missing Asset ID");
	if (!user_id) throw new Error("Missing User ID");
	if (!timecode) throw new Error("Missing Timecode");
	if (!text) throw new Error("Missing User Comment");
	if (!username) throw new Error("Missing User Name");
	// if (!rating) throw new Error("Missing Rating");
	if (!profilePictureNumber && profilePictureNumber !== 0) throw new Error("Missing Profile Picture Number");
	
	commentData.user_token = user_token;
	Logger.log(this.constructor.name, "postAssetComment()", postAssetCommentEndpoint, commentData);
	
	try {
		const response = await axios.post(postAssetCommentEndpoint, commentData);

		// Logger.log(this.constructor.name, "postAssetComment() response", response);

		const data = response.data;
		return data.result;
	}
	catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/viewerComments.js